import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { CurrentClass } from '@openeducation/oe-it-shared-types';
import type { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { QueryKeys } from '../interfaces/query-keys';
import { ActiveClasses } from '../services/active-classes.service';

const TWENTY_SECONDS_DELAY_MS = 20000;

interface UseCurrentTeacherClassProps {
  classroomId?: number;
}
export function useCurrentTeacherClass({
  classroomId,
}: UseCurrentTeacherClassProps) {
  const { environment } = useEnvironmentContext();

  const {
    data: currentClass,
    isLoading: isLoadingCurrentClass,
    error: currentClassError,
  } = useQuery<CurrentClass, AxiosError>(
    [QueryKeys.ActiveClasses, classroomId],
    () => ActiveClasses.getCurrentClass(environment, classroomId),
    {
      enabled: !!classroomId,
      refetchInterval: TWENTY_SECONDS_DELAY_MS,
    }
  );

  return {
    currentClass,
    isLoadingCurrentClass,
    currentClassError,
  };
}
